import "./Header.css";

import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";

import { logout } from "../../store/indexActions";
import { setLoginVisible } from "../../store/modals/modalActions";
import COCTLogo from "../../assets/images/coct-logo.png";
import PayAtLogo from "../../assets/images/Pay@.svg";

interface HeaderProps {
  title?: string;
  hideLoginButton?: boolean;
}

const Header = ({ title, hideLoginButton }: HeaderProps) => {
  const user = useAppSelector((state) => state.auth.user);
  const token = useAppSelector((state) => state.auth.token);
  const dispatch = useAppDispatch();
  const onLoginClicked = () => {
    dispatch(setLoginVisible(true));
  };

  const onLogoutClicked = () => {
    logout(false);
  };

  const onMyProfileClicked = () => {
    window.location.replace("/profile");
  };

  return (
    <div className="header-container">
      <div className="header-content">
        <div className="header-left">
          <div
            style={{
              background: "white",
              paddingTop: 5,
              paddingLeft: 8,
              paddingRight: 5,
            }}
            className="header-image-container"
          >
            <img
              className="header-image"
              src={COCTLogo}
              onClick={() => {
                window.location.replace("/");
              }}
            />
          </div>
          {title && <p className="header-title">{title}</p>}
        </div>

        <div className="header-right">
          {user && token ? (
            <div className="header-button-container">
              <div
                className="login-button"
                onClick={() => onMyProfileClicked()}
              >
                My Profile
              </div>
              <div
                className="login-button"
                style={{
                  color: "white",
                  background: "#e97700",
                }}
                onClick={() => onLogoutClicked()}
              >
                Log Out
              </div>
            </div>
          ) : (
            <div
              className="login-button"
              onClick={onLoginClicked}
              style={{ visibility: !hideLoginButton ? "visible" : "hidden" }}
            >
              Login
            </div>
          )}

          <div className="powered-by">
            <p>Powered by</p>
            <img src={PayAtLogo} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
